/** 3DSwym App ID */
export const APPNAME = 'X3DMCTY_AP'

/** 3DSwym App ID for Analytics */
export const SWYM_APPNAME = 'X3DSWYM_AP'

/** 3DSwym Content Reader App ID */
export const CONTENT_READER_APPNAME = 'X3DVIEW_AP'

/** 3DSwym Control Center App ID */
export const CONTROL_CENTER_APPNAME = 'X3DOPSW_AP'

/** 3DSwym Profile App ID */
export const PROFILE_APPNAME = 'X3DPRFL_AP'

/** 3DSearch App ID */
export const SEARCH_APP = 'X3DSEAR_AP'

/** 3DSearch App ID for user with UAU license */
export const SEARCH_APP_CUSTOMER = 'X3PSEAR_AP'

/** 3DSwym Analytics app ID */
export const SWYM_ANALYTICS_APPNAME = 'X3DSTAT_AP'

/** 6WTagger App ID */
export const TAGGER_APP = 'X3DTAGS_AP'
